import React, { ReactNode } from "react";
import { Box } from "../../../shared/components/ui/chakra";

const InfoItemLeft = ({ children }: { children?: ReactNode }) => {
  return <Box flex={1} maxW="200px">{children}</Box>;
};

export default InfoItemLeft;
